/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultFlowMeta } from '../../models/api-response-paged-result-flow-meta';
import { PagedRequestFlowMetaSearchReq } from '../../models/paged-request-flow-meta-search-req';

export interface SearchFlowMeta$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestFlowMetaSearchReq
}

export function searchFlowMeta(http: HttpClient, rootUrl: string, params: SearchFlowMeta$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultFlowMeta>> {
  const rb = new RequestBuilder(rootUrl, searchFlowMeta.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultFlowMeta>;
    })
  );
}

searchFlowMeta.PATH = '/v1/api/ui/flow-meta/search';
